export default (data, qrCodeIdentifiers = []) => {
  let deliveryCosts = { count: 0, amount: 0 };
  let paymentCosts = {};
  let payments = { REFUND: { count: 0, amount: 0, tipAmount: 0 } };
  let receiptTypes = {};
  let vats = {};
  let articleLevel = {};
  let totalVats = {};

  data.forEach((taReceipt) => {
    if (qrCodeIdentifiers.length > 0) {
      if (
        !qrCodeIdentifiers.some((qrCodeIdentifier) => {
          return taReceipt.sp_qr_code_identifier === qrCodeIdentifier;
        })
      ) {
        return true;
      }
    }

    taReceipt.vats = {};
    taReceipt.totalVats = {};

    if (taReceipt.amount_refunded > 0) {
      payments["REFUND"].count++;
      payments["REFUND"].amount += taReceipt.amount_refunded;
    }

    let totalTaReceipt =
      taReceipt.total_amount +
      (taReceipt.tip_amount ?? 0);
    let partRefunded = taReceipt.amount_refunded / totalTaReceipt;
    if (isNaN(partRefunded)) {
      partRefunded = 0;
    }

    taReceipt.extra_delivery_costs = Math.round(taReceipt.extra_delivery_costs * (1.0 - partRefunded));
    taReceipt.extra_payment_costs = Math.round(taReceipt.extra_payment_costs * (1.0 - partRefunded));
    taReceipt.total_amount = Math.round(taReceipt.total_amount * (1.0 - partRefunded));
    taReceipt.tip_amount = Math.round((taReceipt.tip_amount ?? 0) * (1.0 - partRefunded));

    deliveryCosts.amount += taReceipt.extra_delivery_costs;
    if (taReceipt.extra_delivery_costs > 0) {
      deliveryCosts.count += 1;

      // taReceipt.vats[taReceipt.extra_delivery_costs_vat] = 0;
      // taReceipt.totalVats[taReceipt.extra_delivery_costs_vat] = 0;
      //
      // if (vats[taReceipt.extra_delivery_costs_vat] === undefined) {
      //   vats[taReceipt.extra_delivery_costs_vat] = 0;
      //   totalVats[taReceipt.extra_delivery_costs_vat] = 0;
      // }
      //
      // taReceipt.vats[taReceipt.extra_delivery_costs_vat] += taReceipt.extra_delivery_costs;
      // taReceipt.totalVats[taReceipt.extra_delivery_costs_vat] +=
      //   (taReceipt.extra_delivery_costs / (1 + Number.parseFloat(taReceipt.extra_delivery_costs_vat))) *
      //   taReceipt.extra_delivery_costs_vat;
      //
      // vats[taReceipt.extra_delivery_costs_vat] += taReceipt.extra_delivery_costs;
      // totalVats[taReceipt.extra_delivery_costs_vat] +=
      //   (taReceipt.extra_delivery_costs / (1 + Number.parseFloat(taReceipt.extra_delivery_costs_vat))) *
      //   taReceipt.extra_delivery_costs_vat;
    }

    if (paymentCosts[taReceipt.payment_method] === undefined) {
      paymentCosts[taReceipt.payment_method] = { count: 0, amount: 0 };
    }
    if (taReceipt.extra_payment_costs > 0) {
      // if (vats[taReceipt.extra_payment_costs_vat] === undefined) {
      //   vats[taReceipt.extra_payment_costs_vat] = 0;
      //   totalVats[taReceipt.extra_payment_costs_vat] = 0;
      // }
      //
      // if (taReceipt.vats[taReceipt.extra_payment_costs_vat] === undefined) {
      //   taReceipt.vats[taReceipt.extra_payment_costs_vat] = 0;
      //   taReceipt.totalVats[taReceipt.extra_payment_costs_vat] = 0;
      // }

      // vats[taReceipt.extra_payment_costs_vat] += taReceipt.extra_payment_costs;
      // totalVats[taReceipt.extra_payment_costs_vat] +=
      //   (taReceipt.extra_payment_costs / (1 + Number.parseFloat(taReceipt.extra_payment_costs_vat))) *
      //   taReceipt.extra_payment_costs_vat;
      //
      // taReceipt.vats[taReceipt.extra_payment_costs_vat] += taReceipt.extra_payment_costs;
      // taReceipt.totalVats[taReceipt.extra_payment_costs_vat] +=
      //   (taReceipt.extra_payment_costs / (1 + Number.parseFloat(taReceipt.extra_payment_costs_vat))) *
      //   taReceipt.extra_payment_costs_vat;
    }
    paymentCosts[taReceipt.payment_method].amount += taReceipt.extra_payment_costs;
    paymentCosts[taReceipt.payment_method].count += 1;

    if (payments[taReceipt.payment_method] === undefined) {
      payments[taReceipt.payment_method] = { count: 0, amount: 0, tipAmount: 0 };
    }
    payments[taReceipt.payment_method].amount +=
      taReceipt.total_amount;
    payments[taReceipt.payment_method].count += 1;
    payments[taReceipt.payment_method].tipAmount += taReceipt.tip_amount ?? 0;

    if (receiptTypes[taReceipt.receipt_type] === undefined) {
      receiptTypes[taReceipt.receipt_type] = { count: 0, amount: 0 };
    }
    receiptTypes[taReceipt.receipt_type].count += 1;
    receiptTypes[taReceipt.receipt_type].amount +=
      taReceipt.total_amount +
      (taReceipt.tip_amount ?? 0);


    const taReceiptVats = taReceipt.reporting?.total_amount_per_transaction?.OK?.vats ?? {};
    Object.keys(taReceiptVats).forEach(vatKey => {
      if (vats[vatKey] === undefined) {
        vats[vatKey] = 0;
        totalVats[vatKey] = 0;
      }

      vats[vatKey] += taReceiptVats[vatKey].amount * (1 - partRefunded);
      totalVats[vatKey] += taReceiptVats[vatKey].amount * (1 - partRefunded) / (1 + Number.parseFloat(vatKey)) * vatKey;
      taReceipt.vats[vatKey] = taReceiptVats[vatKey].amount * (1 - partRefunded);
      taReceipt.totalVats[vatKey] = taReceiptVats[vatKey].amount * (1 - partRefunded) / (1 + Number.parseFloat(vatKey)) * vatKey;

    });

    const articles = taReceipt.reporting?.articles ?? {};
    Object.keys(articles).forEach(plu => {
      const pluObject = articles[plu] ?? {};
      Object.keys(pluObject.names).forEach((name) => {
        const prices = pluObject.names[name] ?? {};
        Object.keys(prices).forEach((price) => {
          if (articleLevel[plu] === undefined) {
            articleLevel[plu] = {
              amount: 0,
              count: 0,
              name: name
            };
          }
          articleLevel[plu].amount += (prices[price].amount_closed + prices[price].amount_open) * Number.parseInt(price);
          articleLevel[plu].count += prices[price].amount_closed + prices[price].amount_open;
        });
      });
    });

    // taReceipt.ordergroup.o_m_articles.forEach((oMArticle) => {
    //   if (oMArticle.vat_json !== null) {
    //     //// TODO
    //   } else {
    //     if (vats[oMArticle.vat] === undefined) {
    //       vats[oMArticle.vat] = 0;
    //       totalVats[oMArticle.vat] = 0;
    //     }
    //
    //     if (taReceipt.vats[oMArticle.vat] === undefined) {
    //       taReceipt.vats[oMArticle.vat] = 0;
    //       taReceipt.totalVats[oMArticle.vat] = 0;
    //     }
    //
    //     oMArticle = { ...oMArticle };
    //     oMArticle.total_cost = Math.round(oMArticle.total_cost * (1 - partRefunded));
    //     let vat = oMArticle.total_cost;
    //     let totalVat = (oMArticle.total_cost / (1 + Number.parseFloat(oMArticle.vat))) * oMArticle.vat;
    //
    //     vats[oMArticle.vat] += vat;
    //     totalVats[oMArticle.vat] += totalVat;
    //     taReceipt.vats[oMArticle.vat] += vat;
    //     taReceipt.totalVats[oMArticle.vat] += totalVat;
    //   }
    //
    //   if (articleLevel[oMArticle.plu] === undefined) {
    //     articleLevel[oMArticle.plu] = {
    //       amount: 0,
    //       count: 0,
    //       name: oMArticle.name
    //     };
    //   }
    //   articleLevel[oMArticle.plu].amount += oMArticle.total_cost;
    //   articleLevel[oMArticle.plu].count += oMArticle.amount;
    // });

    taReceipt.exVat = {};
    taReceipt.totalExVat = 0;
    taReceipt.totalIncVat = 0;
    Object.keys(taReceipt.vats).forEach((vat) => {
      taReceipt.totalVats[vat] = Math.round(taReceipt.totalVats[vat]);
      taReceipt.exVat[vat] = taReceipt.vats[vat] - taReceipt.totalVats[vat];
      taReceipt.totalExVat += taReceipt.vats[vat] - taReceipt.totalVats[vat];
      taReceipt.totalIncVat += taReceipt.vats[vat];
    });
  });

  return {
    deliveries: deliveryCosts,
    paymentCosts: paymentCosts,
    payments: payments,
    receiptTypes: receiptTypes,
    totalVats: totalVats,
    vats: vats,
    articleLevel: articleLevel
  };
};
